export default __webpack_public_path__ + "static/media/Animals14.b676c9a7.jpg";